// extracted by mini-css-extract-plugin
export default {"globalFilterContainer":"GlobalFilter_globalFilterContainer__9orEB"};